import {global, lm} from "../../appContext";
import {TBaseOrObservableType} from "../../index";
import {createErrorMessage, getAnyValue} from "../../util/misc";
import * as ko from "knockout";
import buttonHtml from './button.html?raw';

export let template: string = buttonHtml;

interface IParams {
    value: TBaseOrObservableType<any>
    subject?: TBaseOrObservableType<string>
    cls?: TBaseOrObservableType<string>
    icon?: TBaseOrObservableType<string>
    label?: string
    translate?: boolean // translate subject
}

export class viewModel {
    private value: TBaseOrObservableType<any>;
    private subject: TBaseOrObservableType<string> | undefined;
    private cls: TBaseOrObservableType<string>;
    private icon: TBaseOrObservableType<string>;
    private label: string | null;
    private translate: boolean;

    constructor(params: IParams) {
        this.value = params.value;
        this.subject = params.subject;
        this.cls = params.cls ?? 'btn btn-default btn-func';
        this.icon = params.icon ?? 'fa-copy';
        this.label = params.label ?? null;
        this.translate = params.translate ?? true
    }

    onCopyClick() {
        const value = ko.unwrap(this.value);
        try {
            const el = document.createElement('textarea');
            el.value = value;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            const selection = document.getSelection();
            const selected =
                selection && selection.rangeCount > 0
                    ? selection.getRangeAt(0)
                    : false;
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            if (selected && selection) {
                selection.removeAllRanges();
                selection.addRange(selected);
            }
            global.snackbarData({message: `copied subject to clipboard|s:<code>${this.getSubject()}</code>`});
        } catch (err) {
            global.snackbarData(createErrorMessage(String(err)));
        }
    }

    /** Tooltip/snackbar label: translated subject if set, otherwise the copied value. */
    private getSubject(): string {
        const subject = getAnyValue(this.subject) ?? '';
        if (subject) {
            return this.translate ? (lm.t(subject) ?? subject) : subject;
        }
        const value = getAnyValue(this.value);
        return value == null ? '' : String(value);
    }

}
